import { observable, action } from 'mobx';
import { emit, events } from '@estee/elc-service-bus';
import { ProductImageEventAction, ProductImageEventLabel } from '~constants/ProductImage';

export class HoverZoom {
    @observable public isZoomActive: boolean = false;
    @observable public currentZoomSlideIndex: number = 0;
    @observable public xMousePosition: number = 0;
    @observable public yMousePosition: number = 0;

    @action
    public setZoom = (isActive: boolean) => {
        this.isZoomActive = isActive;
    };

    @action
    public setCurrentZoomSlideIndex = (currentZoomSlideIndex: number = 0) => {
        this.currentZoomSlideIndex = currentZoomSlideIndex;
    };

    public handleMousePosition = (event: MouseEvent) => {
        [this.xMousePosition, this.yMousePosition] = [event.clientX, event.clientY];
    };

    public setZoomStatus = (zoomStatus: boolean, eventLabel: string) => {
        this.setZoom(zoomStatus);
        emit(events.PRODUCT_IMAGE_ZOOM_TRIGGERED, {
            eventAction: ProductImageEventAction.ZOOM,
            eventLabel
        });
    };

    public openZoom = () => {
        document.addEventListener('mousemove', this.handleMousePosition);
        this.setZoomStatus(true, ProductImageEventLabel.OPEN);
    };

    public closeZoom = () => {
        document.removeEventListener('mousemove', this.handleMousePosition);
        this.setZoomStatus(false, ProductImageEventLabel.CLOSE);
    };
}
